import { useEffect } from 'react';
import Button from 'react-bootstrap/Button';

function App() {
	useEffect(() => {
		const btn = document.getElementById("time-btn");
		const answerContainer = document.querySelector(".answer-container");
		btn.addEventListener('click', (e) => {
			btn.disabled = true;
			btn.innerHTML = `<div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>Checking With Tony Khan...`;
			setTimeout(function () {
				btn.classList.add("d-none");
				document.querySelector("h1").classList.add("d-none");
				answerContainer.classList.remove("d-none");
			}, 2500);
		});
	}, []);
	return (
		<div className="App">
			<div className="container">
				<div className="row">
					<div className="col-12">
						<h1 className="text-center mt-3">What time is AEW Rampage this week?</h1>
						<Button type="button" className="btn btn-primary mx-auto d-block mt-3" id="time-btn">Click to Find Out</Button>
						<p className="answer-container mt-4 h2 text-center d-none">WHO THE FUCK KNOWS!</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default App;
